export type NcvetQuestionBankAccessFlags = Record<string, boolean | undefined>;

function getAccessFlagsFromUser(user: unknown): NcvetQuestionBankAccessFlags | undefined {
  if (!user || typeof user !== 'object') return undefined;
  const u = user as { organizationId?: unknown };
  const org = u.organizationId;
  if (!org || typeof org !== 'object') return undefined;
  const raw = (org as { ncvetQuestionBankAccess?: unknown }).ncvetQuestionBankAccess;
  if (!raw || typeof raw !== 'object') return undefined;
  return raw as NcvetQuestionBankAccessFlags;
}

/** Maps app user `type` to a key on `organization.ncvetQuestionBankAccess`. */
function accessKeyForUserType(userType: string | undefined): string | null {
  if (!userType) return null;
  switch (userType) {
    case 'assessor':
      return 'assessor';
    case 'assessorAdmin':
      return 'assessorAdmin';
    case 'admin':
    case 'superadmin':
      return 'rootAdmin';
    case 'faculty':
      return 'trainingCenterAdmin';
    default:
      return userType;
  }
}

/**
 * Whether the signed-in user may use NCVET question bank & rubrics management (menus, add questions, etc.).
 * If the organization has no `ncvetQuestionBankAccess` document, access is allowed (backward compatible).
 * If it exists, the flag for the user's role must be strictly `true`.
 */
export function hasNcvetQuestionBankAccess(user: { type?: string; organizationId?: unknown } | null | undefined): boolean {
  const flags = user ? getAccessFlagsFromUser(user) : undefined;
  if (flags == null) return true;

  const key = accessKeyForUserType(user?.type);
  if (!key) return false;
  return flags[key] === true;
}
